export const ROLES = {
	ROLE: {
		ADMIN: {
			ADMIN:{
					NAME:'Administrator',
					ROUTECODE:'administration',
					DEFAULTROUTE:'/dashboard',
					PERMISSIONS: {
						ROUTES: [
							'/dashboard', 
							'/administration/menu', 
							'/administration', 
							'/administration/companies', 
							'/administration/profiles', 
							'/administration/symbols', 
							'/administration/base-symbols', 
							'/administration/symbol-groups', 
							'/administration/ib-tree', 
							'/administration/ibs', 
							'/administration/transactions', 
							'/administration/adjustments', 
							'/administration/adjustment-reason', 
							'/administration/clients', 
							'/administration/accounts', 
							'/administration/users',
							'/administration/contract-details',
							'/administration/ib-account-rules'
							/*'/administration/reports',*/
							
						]
				},
			},
			FINANCE:{
				NAME:'Finance',
				ROUTECODE:'administration',
				DEFAULTROUTE:'/dashboard',
				PERMISSIONS: {
					ROUTES: [
						'/dashboard',
						'/administration/menu',
						'/administration',
						'/administration/companies',
						'/administration/profiles',
						'/administration/symbols',
						'/administration/base-symbols',
						'/administration/symbol-groups',
						'/administration/ib-tree',
						'/administration/ibs',
						'/administration/transactions',
						'/administration/adjustments',
						'/administration/adjustment-reason',
						'/administration/clients',
						'/administration/accounts',
						'/administration/users',
                        '/administration/ib-account-rules',
						'/administration/contract-details'
						/*'/administration/reports',*/

					]
				},
			},
			OPERATIONS:{
				NAME:'Operations',
				ROUTECODE:'administration',
				DEFAULTROUTE:'/dashboard',
				PERMISSIONS: {
					ROUTES: [
						'/dashboard',
						'/administration/menu',
						'/administration',
						'/administration/companies',
						'/administration/profiles',
						'/administration/symbols',
						'/administration/base-symbols',
						'/administration/symbol-groups',
						'/administration/ib-tree',
						'/administration/ibs',
						'/administration/transactions',
						'/administration/adjustments',
						'/administration/adjustment-reason',
						'/administration/clients',
						'/administration/accounts',
						'/administration/users',
                        '/administration/ib-account-rules',
						'/administration/contract-details'
						/*'/administration/reports',*/

					]
				},
			},
		},
		NOTADMIN:{
			CUSTOMER_SUPPORT_USER:{
				NAME:'Administrator',
				ROUTECODE:'administration',
				DEFAULTROUTE:'/dashboard',
				PERMISSIONS: {
					ROUTES: [
						'/dashboard', 
						'/administration/menu', 
						'/administration', 
						'/administration/companies', 
						'/administration/profiles', 
						'/administration/symbols', 
						'/administration/base-symbols', 
						'/administration/symbol-groups', 
						'/administration/ib-tree', 
						'/administration/ibs', 
						'/administration/transactions', 
						'/administration/adjustments', 
						'/administration/adjustment-reason', 
						'/administration/clients', 
						'/administration/accounts', 
						'/administration/users',
						'/administration/contract-details',
                        '/administration/ib-account-rules'
						/*'/administration/reports',*/
						
					]
				},
			},
			COMMON_USER:{
				NAME:'Administrator',
				ROUTECODE:'administration',
				DEFAULTROUTE:'/dashboard',
				PERMISSIONS: {
					ROUTES: [
						'/dashboard', 
						'/administration/menu', 
						'/administration', 
						'/administration/companies', 
						'/administration/profiles', 
						'/administration/symbols', 
						'/administration/base-symbols', 
						'/administration/symbol-groups', 
						'/administration/ib-tree', 
						'/administration/ibs', 
						'/administration/transactions', 
						'/administration/adjustments', 
						'/administration/adjustment-reason', 
						'/administration/clients', 
						'/administration/accounts', 
						'/administration/users',
						'/administration/contract-details',
                        '/administration/ib-account-rules'
						/*'/administration/reports',*/
						
					]
				},
			},
			IB: {
				NAME:'ib',
				ROUTECODE:'ib/reports/statement-summary',
				DEFAULTROUTE:'/ib/reports',
				PERMISSIONS: {
					ROUTES: [
						'/ib/reports',
						'/ib/reports/statement-summary',
						'/ib/reports/contract-details',
						'/ib/reports/rebate-earnings',
						'/ib/reports/trading-accounts-report',
						'/ib/reports/account-statement-report'
					],
				}
			}
		}
	}
};

export const getAuthPermissions = function(grouptypeArray,permissionType,userType="ADMIN") {
	if (grouptypeArray.includes('ADMIN')) {
		return ROLES.ROLE['ADMIN']['ADMIN'].PERMISSIONS[permissionType];
	}

	if (grouptypeArray.includes('CUSTOMER_SUPPORT_USER')) {
		return ROLES.ROLE['NOTADMIN']['CUSTOMER_SUPPORT_USER'].PERMISSIONS[permissionType];
	}

	if (grouptypeArray.includes('COMMON_USER')) {
		return ROLES.ROLE['NOTADMIN']['COMMON_USER'].PERMISSIONS[permissionType];
	}

	if (grouptypeArray.includes('IB')) {
		return ROLES.ROLE['NOTADMIN']['IB'].PERMISSIONS[permissionType];
	}

};


export const getDefaultProps = function(grouptypeArray,userType="ADMIN") {


	if (grouptypeArray.hasOwnProperty('permissions')) {
		grouptypeArray = grouptypeArray.permissions;
	}
	
	if (grouptypeArray.includes('ADMIN')) {
		return ROLES.ROLE['ADMIN']['ADMIN'];
	}

	if (grouptypeArray.includes('COMMON_USER')) {
		return ROLES.ROLE['NOTADMIN']['COMMON_USER'];
	}

	if (grouptypeArray.includes('CUSTOMER_SUPPORT_USER')) {
		return ROLES.ROLE['NOTADMIN']['CUSTOMER_SUPPORT_USER'];
	}

	if (grouptypeArray.includes('IB')) {
		return ROLES.ROLE['NOTADMIN']['IB'];
	}

};

export const getDefaultRoute = function(grouptypeArray,userType="ADMIN") {
	if (grouptypeArray.hasOwnProperty('permissions')) {
		grouptypeArray = grouptypeArray.permissions;
	}
	
	if (grouptypeArray.includes('ADMIN')) {
		return ROLES.ROLE['ADMIN']['ADMIN'].DEFAULTROUTE;
	}

	if (grouptypeArray.includes('COMMON_USER')) {
		return ROLES.ROLE['NOTADMIN']['COMMON_USER'].DEFAULTROUTE;
	}

	if (grouptypeArray.includes('CUSTOMER_SUPPORT_USER')) {
		return ROLES.ROLE['NOTADMIN']['CUSTOMER_SUPPORT_USER'].DEFAULTROUTE;
	}

	if (grouptypeArray.includes('IB')) {
		return ROLES.ROLE['NOTADMIN']['IB'].DEFAULTROUTE;
	}

};




// WEBPACK FOOTER //
// ./src/constants/authorisation.js